/* ============================================================
   CaseKaro Homepage UX Fixes v1  (assets/ck-ux-fixes.js)
   Date: 2026-06-11  |  Theme: 142974353526 "Working On It" (DRAFT)

   Tiny progressive-enhancement helper for two CSS-driven fixes:

   [FIX 2] On mobile homepage, hide the redundant sticky HEADER
           search while the hero finder is in view; reveal it once
           the shopper scrolls past the hero. Toggles
           <html class="ck-hide-header-search">.
   [FIX 4] Toggle <html class="ck-cart-empty"> so the cart count
           badge hides when the cart is empty.

   The CKSAFE10 auto-apply (10% cart reward) was removed on
   19 Oct 2026 when the 10% reward was dropped.

   No external deps. If this file fails to load, the CSS fallbacks
   keep everything usable (header search simply stays visible).

   ROLLBACK: delete this file + remove its <script> include in
   layout/theme.liquid (marked "CaseKaro UX fixes").
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- [FIX 2] mobile header-search scroll reveal ---------- */
  function initHeaderSearchReveal() {
    if (!document.body || document.body.className.indexOf('template-index') === -1) return;
    var hero = document.querySelector('.mf-hero');
    if (!hero) return;

    var ticking = false;

    function update() {
      ticking = false;
      // Only act on mobile widths; on desktop never hide the header search.
      if (window.innerWidth > 749) {
        root.classList.remove('ck-hide-header-search');
        return;
      }
      // Hide while the hero is still meaningfully in view.
      var bottom = hero.getBoundingClientRect().bottom;
      if (bottom > 100) {
        root.classList.add('ck-hide-header-search');
      } else {
        root.classList.remove('ck-hide-header-search');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    update(); // set initial state (hidden at top on mobile)
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------- [FIX 4] empty-cart badge state ---------- */
  function getCartCount() {
    var el = document.querySelector('[id$="__header"] #nav-user li.cart #cart-count');
    if (!el) return null;
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function updateCartState() {
    var n = getCartCount();
    if (n === null) return;
    root.classList.toggle('ck-cart-empty', n === 0);
  }

  function initCartState() {
    updateCartState();
    var el = document.querySelector('[id$="__header"] #nav-user li.cart #cart-count');
    if (el && window.MutationObserver) {
      new MutationObserver(updateCartState).observe(el, { childList: true, characterData: true, subtree: true });
    }
    // Theme fires cart events on add/remove; re-check on common ones.
    ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(updateCartState, 60); });
    });
  }

  function init() {
    initHeaderSearchReveal();
    initCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
